/* ============ Undr Style theme JS ============ */

/* ---- Mobile drawer ---- */
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-drawer-open]');
  const closeBtn = e.target.closest('[data-drawer-close]');
  const drawer = document.getElementById('MobileDrawer');
  if (!drawer) return;
  if (openBtn) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  if (closeBtn || e.target.classList.contains('mobile-drawer__overlay')) {
    drawer.classList.remove('is-open'); document.body.style.overflow = '';
  }
});

/* ---- Tabs ---- */
document.querySelectorAll('[data-tabs]').forEach((tabs) => {
  const btns = tabs.querySelectorAll('.tabs__btn');
  const panels = tabs.querySelectorAll(':scope .tabs__panel');
  btns.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      btns.forEach((b) => b.classList.remove('is-active'));
      panels.forEach((p) => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (panels[i]) panels[i].classList.add('is-active');
    });
  });
});

/* ---- Slideshow ---- */
document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
  const track = slideshow.querySelector('.slideshow__slides');
  const slides = slideshow.querySelectorAll('.slideshow__slide');
  const dots = slideshow.querySelectorAll('.slideshow__dot');
  const autoplay = slideshow.dataset.autoplay === 'true';
  const speed = (parseInt(slideshow.dataset.speed, 10) || 5) * 1000;
  const rtl = document.documentElement.dir === 'rtl';
  let index = 0;
  let timer;

  const go = (i) => {
    index = (i + slides.length) % slides.length;
    const dir = rtl ? 1 : -1;
    track.style.transform = `translateX(${dir * index * 100}%)`;
    dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
  };
  dots.forEach((d, di) => d.addEventListener('click', () => { go(di); restart(); }));
  const restart = () => { if (autoplay && slides.length > 1) { clearInterval(timer); timer = setInterval(() => go(index + 1), speed); } };
  restart();
});

/* ---- Carousels ---- */
document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('.product-carousel__track');
  if (!track) return;
  const step = () => track.querySelector(':scope > *') ? track.querySelector(':scope > *').offsetWidth + 16 : 300;
  carousel.querySelectorAll('[data-carousel-prev]').forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
  carousel.querySelectorAll('[data-carousel-next]').forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
});

/* ---- Quantity selectors ---- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty-change]');
  if (!btn) return;
  const input = btn.closest('.quantity-selector').querySelector('input');
  const delta = parseInt(btn.dataset.qtyChange, 10);
  const next = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 0) + delta);
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---- Cart count refresh helper ---- */
function updateCartCount() {
  fetch(`${window.routes.cart_url}.js`)
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
    });
}

/* ---- AJAX add to cart (product forms + quick buy) ---- */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('form[data-ajax-cart]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  const original = btn ? btn.textContent : '';
  if (btn) { btn.setAttribute('disabled', ''); btn.textContent = '...'; }
  const formData = new FormData(form);
  fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: formData })
    .then((r) => r.json())
    .then((data) => {
      if (data.status && data.status !== 200) throw new Error(data.description || window.cartStrings.error);
      updateCartCount();
      if (btn) { btn.textContent = '✓'; setTimeout(() => { btn.textContent = original; btn.removeAttribute('disabled'); }, 1200); }
    })
    .catch((err) => {
      alert(err.message || window.cartStrings.error);
      if (btn) { btn.textContent = original; btn.removeAttribute('disabled'); }
    });
});

/* ---- Cart page: quantity change / remove ---- */
document.addEventListener('change', (e) => {
  const input = e.target.closest('[data-cart-qty]');
  if (!input) return;
  changeCartLine(input.dataset.line, parseInt(input.value, 10));
});
document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-cart-remove]');
  if (!removeBtn) return;
  e.preventDefault();
  changeCartLine(removeBtn.dataset.line, 0);
});
function changeCartLine(line, quantity) {
  fetch(window.routes.cart_change_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line, 10), quantity })
  })
    .then((r) => r.json())
    .then(() => window.location.reload())
    .catch(() => alert(window.cartStrings.error));
}

/* ---- Product page: variant picker ---- */
document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
  const variantsScript = wrapper.querySelector('[data-variants-json]');
  if (!variantsScript) return;
  const variants = JSON.parse(variantsScript.textContent);
  const idInput = wrapper.querySelector('input[name="id"]');
  const priceEl = wrapper.querySelector('[data-price]');
  const compareEl = wrapper.querySelector('[data-compare-price]');
  const submitBtn = wrapper.querySelector('[data-submit]');
  const moneyFormat = wrapper.dataset.moneyFormat || '{{amount}}';

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  const onChange = () => {
    const selected = [...wrapper.querySelectorAll('.variant-options input:checked')].map((i) => i.value);
    const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    if (!variant) {
      if (submitBtn) { submitBtn.setAttribute('disabled', ''); submitBtn.textContent = window.variantStrings.unavailable; }
      return;
    }
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.classList.add('hidden');
      }
    }
    if (submitBtn) {
      if (variant.available) { submitBtn.removeAttribute('disabled'); submitBtn.textContent = window.variantStrings.addToCart; }
      else { submitBtn.setAttribute('disabled', ''); submitBtn.textContent = window.variantStrings.soldOut; }
    }
    if (variant.featured_media) {
      const target = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (target) selectGalleryImage(target);
    }
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  wrapper.querySelectorAll('.variant-options input').forEach((input) => input.addEventListener('change', onChange));
});

/* ---- Product gallery thumbs ---- */
function selectGalleryImage(thumb) {
  const gallery = thumb.closest('[data-gallery]');
  if (!gallery) return;
  const main = gallery.querySelector('.product-gallery__main img');
  const src = thumb.dataset.fullSrc;
  if (main && src) { main.src = src; main.srcset = ''; }
  gallery.querySelectorAll('.product-gallery__thumb').forEach((t) => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
}
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.product-gallery__thumb');
  if (thumb) selectGalleryImage(thumb);
});
